import React, { useEffect } from 'react';
import { ThemeProvider, CircularProgress, CssBaseline } from '@mui/material';
import { useDispatch } from 'react-redux';
import { SnackbarProvider } from 'notistack';
import { AuthProvider, useAuth } from 'react-oidc-context';

import oidcConfig from 'config/keycloak';
import theme from 'themes';
import { retrieveAuthFromLocalStorage } from 'stores/auth';
import { StandaloneSnackbarConfigurator } from 'components/StandaloneSnackbar/StandaloneSnackbar';
import { setAuthInstance } from 'utils/keycloak-adapter';
import { getSubdomain, ESubdomain } from 'utils/url';
import './App.scss';
import Routes from './Routes';

const AppContent = () => {
  const auth = useAuth();
  setAuthInstance(auth);

  return <Routes />;
};

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(retrieveAuthFromLocalStorage());
  }, []);

  useEffect(() => {
    const subdomain = getSubdomain();

    const link = document.querySelector("link[rel='icon']") as HTMLLinkElement;

    if (subdomain === ESubdomain.SEM_PARAR) {
      if (link) link.href = '/semparar_favicon.ico';
      document.title = 'SEM PARAR - Recebíveis';
    } else if (subdomain === ESubdomain.CARGILL) {
      if (link) link.href = '/cargill_favicon.ico';
      document.title = 'Cargill - Portal de Antecipação';
    } else {
      document.title = 'TORQI - Recebíveis';
    }
  }, []);

  return (
    <ThemeProvider theme={theme()}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={5}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        autoHideDuration={3000}
        iconVariant={{
          info: (
            <CircularProgress
              size={15}
              sx={{
                marginRight: 4,
              }}
              color="primary"
            />
          ),
        }}
      >
        <StandaloneSnackbarConfigurator />
        <AuthProvider {...oidcConfig}>
          <AppContent />
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
